import { render, staticRenderFns } from "./FinalDraftHistory.vue?vue&type=template&id=20be38e4&scoped=true&"
import script from "./FinalDraftHistory.vue?vue&type=script&lang=js&"
export * from "./FinalDraftHistory.vue?vue&type=script&lang=js&"
import style0 from "./FinalDraftHistory.vue?vue&type=style&index=0&id=20be38e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20be38e4",
  null
  
)

export default component.exports